import React from 'react';
import styles from './summaryCard.module.scss'; // Custom CSS module for styles
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const DealSummaryCard = ({dealSummary}) => {
  const navigate = useNavigate();

  const handleBoxClick = (status) => {
    navigate(`/deal-transition/deal-approval/effort-approval?status=${status}`);
  };

  return (
    <div>
      <div className={styles['deal-approval-summary-container']}>
        {dealSummary.map((deal) => (
          <Box key={deal.id} className={styles['deal-approval-summary-box']}
            onClick={() => handleBoxClick(deal.status)}
          >
            <div className={styles['deal-approval-summary-heading']}>{deal.heading}</div>
            <div className={styles['deal-approval-summary-inner-box']}>
              {deal.image && (
                <img
                  src={deal.image}
                  className={styles['deal-approval-summary-image']}
                  alt={deal.heading}
                />
              )}
              <div className={styles['deal-approval-summary-value']}>{deal.value}</div>
            </div>
          </Box>
        ))}
      </div>
    </div>
  );
};

export default DealSummaryCard;

DealSummaryCard.propTypes = {
  dealSummary: PropTypes.object.isRequired,
};
